const PROTOCAL = "https://"

export const GEOSERVER_URL = PROTOCAL + 'map-vungnguyenlieu.inoste.vn/geoserver'
export const WMS_URL = GEOSERVER_URL + '/wms/'


export const SERVER_URL = PROTOCAL + 'api-travel.dev.metatwin.vn'